import React from "react";
import { ExpandMore } from "@mui/icons-material";
import { Box, IconButton, Typography, useTheme } from "@mui/material";
import { OcRoleFilterHeaderProps } from "./role-filter-header";
import { IconifyIcon, InlineIcon } from "@iconify/react";
import { useOcIsMobile as useOcIsMobileDI } from "oc/hooks";

type OcRoleFilterHeaderViewProps = Omit<OcRoleFilterHeaderProps, "icon"> & {
  icon: string | IconifyIcon;
  useOcIsMobile?: typeof useOcIsMobileDI;
};

export const OcRoleFilterHeaderView: React.FC<OcRoleFilterHeaderViewProps> = ({
  opened,
  handleOpen,
  disabled,
  id,
  noButton,
  title,
  icon,
  titleExtra,
  useOcIsMobile = useOcIsMobileDI,
}) => {
  const theme = useTheme();
  const isMobile = useOcIsMobile();
  // If it's isMobile and has a label next to the title,
  // a different layout is needed.
  const hideIcon = isMobile && Boolean(titleExtra);

  const role = React.isValidElement(titleExtra) ? (titleExtra as any).props?.children?.props?.role : undefined;

  const collapseId = role ? `${title + role}` : "filter-collapse"
  return (
    <Box
      id={id}
      data-testid={id}
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        height: hideIcon ? "auto" : "44px",
        padding: hideIcon ? "8px 24px" : "0px 24px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
        }}
      >
        {!hideIcon && (
          <Box
            padding="10px 24px 10px 0px" // TODO f Profile roles / Add mass roles add role - 24px side padding.
            sx={{
              display: "flex",
            }}
            data-testid="oc-role-filter-header-view-icon"
          >
            <InlineIcon
              icon={icon}
              height="32px"
              color={theme.palette.owGray.main}
            />
          </Box>
        )}
        <Box
          sx={{
            display: "flex",
            flexDirection: hideIcon ? "column" : "row",
            alignItems: hideIcon ? "start" : "center",
            gap: hideIcon ? "8px" : "16px",
          }}
        >
          <Typography variant="h5">{title}</Typography>
          {titleExtra}
        </Box>
      </Box>

      <Box>
        {!noButton && (
          <IconButton
            id={collapseId}
            sx={{
              height: "24px",
              width: "24px",
              transform: opened && !disabled ? "rotate(-180deg)" : "",
              transition: "transform 0.3s ease-in-out",
            }}
            data-testid="oc-role-filter-header-view-button"
            onClick={handleOpen}
            disabled={disabled}
          >
            <ExpandMore />
          </IconButton>
        )}
      </Box>
    </Box>
  );
};
